import { render, staticRenderFns } from "./DropzoneBox.vue?vue&type=template&id=94275766"
import script from "./DropzoneBox.vue?vue&type=script&lang=js"
export * from "./DropzoneBox.vue?vue&type=script&lang=js"
import style0 from "./DropzoneBox.vue?vue&type=style&index=0&id=94275766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports